import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class International_exhibition extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                International Exhibition
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Services</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>International Exhibition</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section
                    className="about-section section-padding fix bg-cover"
                    style={{ backgroundImage: 'url("assets/img/service/service-bg-2.jpg")' }}
                >
                    <div className="container">
                        <div className="about-wrapper style-2">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="about-image-items">
                                        <div className="circle-shape">
                                            <img src="assets/img/about/circle.png" alt="shape-img" />
                                        </div>
                                        <div
                                            className="about-image-1 bg-cover wow fadeInLeft"
                                            data-wow-delay=".3s"
                                            style={{
                                                // backgroundImage: 'url("assets/img/internation_exhibition_img.png")'
                                                backgroundImage: 'url("assets/img/internation_exhibition_img_2.png")',
                                                width:'500px !important'
                                            }}
                                        >
                                            <div className="about-image-2 wow fadeInUp" data-wow-delay=".5s">
                                                <img src="assets/img/about/04.jpg" alt="about-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 mt-4 mt-lg-0">
                                    <div className="about-content">
                                        <div className="section-title mb-3 mxw-650">
                                            <div className="subtitle">
                                                {" "}
                                                <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                <span>International Exhibitions</span>
                                                <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                            </div>
                                            <h2 className="title">
                                                Participation in International exhibitions
                                            </h2>
                                        </div>
                                        <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                            India ITME Society through its extensive network and years of
                                            experience will create an ease of participation for Indian textile
                                            engineering industry by identifying the best and emerging
                                            international textile machinery and engineering exhibitions. It
                                            will assist in global participation by way of
                                        </p>
                                        <div className="why_india_css wow fadeInUp" data-wow-delay=".6s">
                                            <ul>
                                                <li>Pavilion Creation</li>
                                                <li>Specialized Negotiated booth space rates</li>
                                                <li>Brochure/ Catalog Participation</li>
                                                <li>Networking Table space</li>
                                            </ul>
                                        </div>
                                        {/* <div class="about-author">
                          <div class="about-button wow fadeInUp" data-wow-delay=".5s">
                              <a href="about.html" class="theme-btn">
                                  Explore More
                                  <i class="fa-solid fa-arrow-right-long"></i>
                              </a>
                          </div>
                      </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>




                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(International_exhibition));